import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

export default function useIsMobile() {
    const windowWidth = ref(window.innerWidth);
    const isMobile = computed(() => {
        // Early return for screens larger than Intellicheck max width
        if (windowWidth.value > 985) return false;

        const ua = navigator.userAgent;
        if (/mobi|android|webos|iphone|ipad|ipod|blackBerry|iemobile|opera mini/i.test(ua.toLowerCase())) return true;

        return windowWidth.value <= 580;
    });

    const handleResize = () => {
        windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
        window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize);
    });

    return { isMobile };
}
